export const getEnumKeyByValue = <T extends Record<string, string | number>>(
  enumObj: T,
  value: string | number,
): keyof T => {
  return Object.keys(enumObj).find((key) => enumObj[key as keyof T] === value) as keyof T;
};
